import { Link } from 'react-router-dom';

const steps = [
  {
    number: '01',
    icon: 'ri-heart-3-line',
    title: 'Acolhimento e Anamnese',
    subtitle: 'Sessão 1',
    desc: 'Ouvimos você e sua família. Exploramos a história de vida, o contexto escolar e as preocupações com cuidado e sem julgamentos.',
    color: 'bg-coral/10 text-coral-dark border-coral/20',
    iconBg: 'bg-coral/20',
  },
  {
    number: '02',
    icon: 'ri-brain-line',
    title: 'Avaliação Cognitiva e de Aprendizagem',
    subtitle: 'Sessões 2 a 5',
    desc: 'Aplicação de protocolos reconhecidos de forma lúdica e respeitosa, no ritmo da criança.',
    color: 'bg-teal/10 text-teal-dark border-teal/20',
    iconBg: 'bg-teal/20',
  },
  {
    number: '03',
    icon: 'ri-file-text-line',
    title: 'Devolutiva e Plano de Intervenção',
    subtitle: 'Sessão Final',
    desc: 'Apresentamos os resultados de forma clara, com orientações práticas para a família e a escola. O diagnóstico é apenas o começo.',
    color: 'bg-amber-50 text-amber-700 border-amber-200',
    iconBg: 'bg-amber-100',
  },
];

export default function JourneyPreview() {
  return (
    <section className="py-16 md:py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block text-teal text-xs font-700 font-sans uppercase tracking-widest mb-3">
            Como funciona
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-600 text-navy mb-4">
            A Jornada de Avaliação
          </h2>
          <p className="text-slate-500 font-sans text-base md:text-lg font-300 max-w-2xl mx-auto leading-relaxed">
            Um processo estruturado, transparente e pensado para deixar você e seu filho seguros em cada etapa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative">
          <div className="absolute top-12 left-[16.5%] right-[16.5%] h-0.5 bg-gradient-to-r from-coral/30 via-teal/30 to-amber-200 hidden lg:block" />

          {steps.map((step) => (
            <div key={step.number} className={`relative bg-white border rounded-2xl p-6 md:p-8 ${step.color} transition-all duration-300 hover:-translate-y-1`}>
              <div className="flex items-center justify-between mb-5 md:mb-6">
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${step.iconBg}`}>
                  <i className={`${step.icon} text-xl`} />
                </div>
                <span className="font-serif text-4xl font-700 opacity-10">{step.number}</span>
              </div>
              <span className="text-xs font-700 font-sans uppercase tracking-wider opacity-60 block mb-2">
                {step.subtitle}
              </span>
              <h3 className="font-serif text-lg md:text-xl font-600 text-navy mb-3">{step.title}</h3>
              <p className="font-sans text-sm text-slate-500 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-12">
          <Link
            to="/jornada"
            className="inline-flex items-center gap-2 text-teal font-sans font-600 text-sm cursor-pointer hover:text-teal-dark transition-colors"
          >
            Ver a jornada completa
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
